/* eslint-disable max-len */
import {
  Utils,
  QUERY_PARAM_BASE_CONFIGURATION_ID_FOR_SELECTIONS,
  QUERY_PARAM_PLA_CONFIGURATION_GUID
} from '../app/utils/urlUtils';

export const setPagePlaCanonical = () => {
  const baseURI = Utils.getBaseURI();
  const baseConfig = Utils.getParameterByName(QUERY_PARAM_BASE_CONFIGURATION_ID_FOR_SELECTIONS);
  const plaGuid = Utils.getParameterByName(QUERY_PARAM_PLA_CONFIGURATION_GUID);
  const plaCanonicaId = 'link__pla-canonical';
  let linkPlaCanonical = document.querySelector(`#${plaCanonicaId}`);
  if (!linkPlaCanonical) {
    const link = document.createElement('link');
    link.id = plaCanonicaId;
    link.rel = 'canonical';
    link.href = `${baseURI}?${QUERY_PARAM_PLA_CONFIGURATION_GUID}=${plaGuid}&${QUERY_PARAM_BASE_CONFIGURATION_ID_FOR_SELECTIONS}=${baseConfig}`;
    document.head.appendChild(link);
  }

  const plaAlternateId = 'link__pla-alternate';
  let linkAlternate = document.querySelector(`#${plaAlternateId}`);

  if (!linkAlternate) {
    const link = document.createElement('link');
    link.id = plaAlternateId;
    link.rel = 'alternate';
    link.media = 'only screen and (max-width: 640px)';
    link.href = `${baseURI}?${QUERY_PARAM_PLA_CONFIGURATION_GUID}=${plaGuid}&${QUERY_PARAM_BASE_CONFIGURATION_ID_FOR_SELECTIONS}=${baseConfig}`;
    document.head.appendChild(link);
  }
};